/**
 * PDL `companies.inferred_revenue` buckets. `revenue_ranges[].text` must be
 * one of these strings verbatim — the index stores the bucket unchanged.
 */
export const REVENUE_RANGES: { value: string; label: string }[] = [
  "$0-$1M",
  "$1M-$10M",
  "$10M-$25M",
  "$25M-$50M",
  "$50M-$100M",
  "$100M-$250M",
  "$250M-$500M",
  "$500M-$1B",
  "$1B-$10B",
  "$10B+",
].map((bucket) => ({ value: bucket, label: bucket }));

/** Preset bounds (USD) offered by the Funding Raised min/max selects. */
export const FUNDING_AMOUNT_PRESETS: readonly number[] = [
  500_000,
  1_000_000,
  5_000_000,
  10_000_000,
  25_000_000,
  50_000_000,
  100_000_000,
  250_000_000,
  500_000_000,
  1_000_000_000,
  5_000_000_000,
];

/** Compact USD label: 500000 → "$500K", 25000000 → "$25M", 1500000000 → "$1.5B". */
export function formatFundingAmountLabel(value: number): string {
  const units: [number, string][] = [[1e9, "B"], [1e6, "M"], [1e3, "K"]];
  for (const [size, suffix] of units) {
    if (value >= size) {
      return `$${Number((value / size).toFixed(2)).toString()}${suffix}`;
    }
  }
  return `$${value.toLocaleString("en-US")}`;
}
